import React, { Component } from "react";
import exp from "./exp.jpg";
export default class ExperienceImg extends Component {
  render() {
    return <img src={exp} alt="" />;
  }
}
